import {
  AmazonIcon,
  Container,
  FameplayIcon,
  MengmiuIcon,
  PartnersIconsContainer,
  PartnersTitle,
  PublicisIcon,
  SemrushIcon,
} from './styled';

export type PartnersProps = {
  backgroundColor?: string;
  isSmallFromTablet?: boolean;
};

export const Partners = ({ backgroundColor, isSmallFromTablet = false }: PartnersProps) => (
  <Container backgroundColor={backgroundColor} isSmallFromTablet={isSmallFromTablet}>
    <PartnersTitle isSmallFromTablet={isSmallFromTablet}>Over 3 400 000 happy users</PartnersTitle>
    <PartnersIconsContainer isSmallFromTablet={isSmallFromTablet}>
      <FameplayIcon isSmallFromTablet={isSmallFromTablet} />
      <AmazonIcon isSmallFromTablet={isSmallFromTablet} />
      <SemrushIcon isSmallFromTablet={isSmallFromTablet} />
      <MengmiuIcon isSmallFromTablet={isSmallFromTablet} />
      <PublicisIcon isSmallFromTablet={isSmallFromTablet} />
    </PartnersIconsContainer>
  </Container>
);
